var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex tw-justify-between"},[_c('span',{staticClass:"tw-font-bold"},[_vm._v(_vm._s(_vm.title)+_vm._s(_vm.separator))]),_c('span',{staticClass:"tw-font-extralight tw-italic"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }